import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import * as React from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
var Space = function Space(props) {
  var _context, _context2;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var _getCompProps = getCompProps('Space', userDefaultProps, props),
    style = _getCompProps.style,
    className = _getCompProps.className,
    children = _getCompProps.children,
    direction = _getCompProps.direction,
    align = _getCompProps.align,
    size = _getCompProps.size,
    split = _getCompProps.split,
    wrap = _getCompProps.wrap,
    customPrefixcls = _getCompProps.prefixCls;
  // className前缀
  var prefixCls = getPrefixCls(pkgPrefixCls, 'space', customPrefixcls);
  var mapSize = {
    small: 8,
    middle: 16,
    large: 24
  };
  var getGap = function getGap(size) {
    return mapSize[size] || size || 0;
  };
  var gap = {
    col: 0
  };
  if (Array.isArray(size)) {
    var _size = _slicedToArray(size, 2),
      col = _size[0],
      row = _size[1];
    gap.col = getGap(col);
    gap.row = getGap(row);
  } else {
    gap.col = getGap(size);
  }
  var styleString = _extends({
    '--cgap': gap.col + 'px',
    '--rgap': gap.row && gap.row + 'px'
  }, style);
  var spaceClass = classNames(prefixCls, className, _concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, direction), _concatInstanceProperty(_context2 = "".concat(prefixCls, "-align-")).call(_context2, align), _defineProperty({}, "".concat(prefixCls, "-wrap"), wrap));
  var renderItems = function renderItems(children) {
    var _context3;
    return _mapInstanceProperty(_context3 = React.Children).call(_context3, children, function (child) {
      if (child === null || child === void 0 ? void 0 : child.type) {
        if (_typeof(child.type) === 'symbol') {
          return renderItems(child.props.children);
        }
        return child;
      }
      if (child) return /*#__PURE__*/React.createElement("span", null, child);
    });
  };
  var Items = renderItems(children);
  if (split) {
    for (var i = 1; i < Items.length; i += 2) {
      _spliceInstanceProperty(Items).call(Items, i, 0, /*#__PURE__*/React.cloneElement((split === null || split === void 0 ? void 0 : split.type) ? split : /*#__PURE__*/React.createElement("span", null, split), {
        key: i
      }));
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: spaceClass,
    style: styleString
  }, Items);
};
Space.displayName = 'Space';
export default Space;